import { EMPTY_FUNCTION } from '../../../constants/common'
import { WidgetContext } from '../../../context'

function WidgetContextProvider({
  bottomEndIntersectionElement,
  children,
  isEditMode,
  isExpanded,
  isSkeleton,
  registerExpandButton = EMPTY_FUNCTION,
  shadowElement,
  topEndIntersectionElement,
  onDisableEditMode,
  onEnableEditMode,
  onToggleExpanded,
}) {
  const context = {
    bottomEndIntersectionElement,
    handleDisableEditMode: onDisableEditMode,
    handleEnableEditMode: onEnableEditMode,
    handleToggleExpanded: onToggleExpanded,
    isEditMode,
    isExpanded,
    isSkeleton,
    registerExpandButton,
    shadowElement,
    topEndIntersectionElement,
  }

  return <WidgetContext value={context}>{children}</WidgetContext>
}

export default WidgetContextProvider
